module.exports = __webpack_public_path__ + "static/media/sejal_pathak.14568fa0.png";